import React, { Component } from 'react';

import PropTypes from 'prop-types';

import FileSectionHeaderActions from './FileSectionHeaderActions';
import FileSectionHeaderInfo from './FileSectionHeaderInfo';

export default class FileSectionHeader extends Component {
  static Actions = FileSectionHeaderActions;
  static Info = FileSectionHeaderInfo;

  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { children } = this.props;

    return <div className="file__section__header">{children}</div>;
  }
}
